import React from 'react'
import { Col, Row } from 'react-bootstrap'
import {
    sampleimage0,
    sampleimage1,
    sampleimage2,
    sampleimage3,
    sampleimage4,
    sampleimage5,
    sampleimage6,
    sampleimage7,
    sampleimage8,
    sampleimage9,
    sampleimage10,
    sampleimage11,
} from '../AllImages'

function ImageContainer() {
    return (
        <>
            <h2>Images Generated Using SpeakPic</h2>
            <Row className="gy-3">
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage0}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>
                                    A cyberpunk dystopia where neon lights
                                    illuminate towering skyscrapers
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage1}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>
                                    A futuristic space station orbiting a
                                    distant planet
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage2}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>
                                    A post-apocalyptic wasteland reclaimed by
                                    nature
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage3}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>
                                    A steampunk metropolis floating in the
                                    clouds, powered by giant gears and steam
                                    engines
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage4}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>An Ice creme shop in a desert</p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage5}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>
                                    An underwater city filled with
                                    bioluminescent creatures and glowing coral
                                    reefs
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage6}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>Ancient Indian Temple</p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage7}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>basket of oranges</p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage8}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>candles made of chocolate</p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage9}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>panda driving a motor-bike</p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage10}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>people living on mars</p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3} lg={3} xxl={3}>
                    <div className="card">
                        <div className="card-body p-0 containerDiv">
                            <img
                                src={sampleimage11}
                                width="100%"
                                className="image"
                            />
                            <div className="overlayDiv">
                                <p>sports car in a forest</p>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default ImageContainer
